package one.devsbox.www.ui.widgets

import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import one.devsbox.www.www_portal.generated.resources.Res
import one.devsbox.www.www_portal.generated.resources.ui_devices_detail_devicedui_status_offline
import one.devsbox.www.www_portal.generated.resources.ui_devices_detail_devicedui_status_online
import org.jetbrains.compose.resources.stringResource

@Composable
fun InternetStatusBadge(online: Boolean, modifier: Modifier = Modifier) {
    val statusContainerColor = if (online) {
        MaterialTheme.colorScheme.secondaryContainer
    } else {
        MaterialTheme.colorScheme.errorContainer
    }
    val statusContentColor = if (online) {
        MaterialTheme.colorScheme.onSecondaryContainer
    } else {
        MaterialTheme.colorScheme.onErrorContainer
    }
    Surface(
        modifier = modifier.padding(8.dp),
        color = statusContainerColor,
        shape = RoundedCornerShape(2.dp)
    ) {
        Text(
            text = if (online) stringResource(Res.string.ui_devices_detail_devicedui_status_online) else stringResource(
                Res.string.ui_devices_detail_devicedui_status_offline
            ),
            modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp),
            style = MaterialTheme.typography.labelSmall,
            color = statusContentColor,
            fontSize = 9.sp,
            fontWeight = FontWeight.Bold
        )
    }
}